<script lang="ts">
  import { page } from '$app/stores';
  import { locale } from '$lib/i18n';
  
  // Define the navigation items with icons
  const items = $state([
    {
      title: 'Casino',
      icon: 'casino',
      path: "/casino",
      iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m7.5 12 3 3 6-6"/></svg>`
    },
    {
      title: 'Sports',
      icon: "sports",
      path: "/sports",
      iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M4.93 4.93a19 19 0 0 1 14.14 14.14M19.07 19.07A19 19 0 0 1 4.93 4.93"/><path d="M8 12a4 4 0 0 1 8 0"/><path d="M12 16a4 4 0 0 1 0-8"/></svg>`
    }
  ]);

  // Track which option is selected
  let activeIndex = $state(0);
  
  // Update the selected item whenever the URL changes
  $effect(() => {
    const path = $page.url.pathname;
    const index = items.findIndex(item => path.includes(item.path));
    activeIndex = index >= 0 ? index : 0;
  });
</script>

<div class="nav-switcher relative flex items-center p-1 bg-gray-800 rounded-lg">
  <div 
    class="nav-indicator absolute h-full rounded-md bg-gray-700 transition-all duration-300 ease-in-out" 
    style="width: calc(100% / {items.length}); left: calc({activeIndex} * (100% / {items.length}));"
  ></div>
  
  {#each items as item, index}
    <a 
      href="/{$locale}{item.path}" 
      class="nav-item relative z-10 flex items-center justify-center gap-2 py-2 px-4 text-sm font-medium transition-colors duration-200 rounded-md w-full text-center"
      class:text-[#FF3E00]={activeIndex === index}
      class:text-white={activeIndex !== index}
    >
      <span class="icon" class:text-[#FF3E00]={activeIndex === index}>
        {@html item.iconSvg}
      </span>
      <span>{item.title}</span>
    </a>
  {/each}
</div>

<style lang=scss>
  .nav-switcher {
    width: 100%;
    max-width: 300px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  
  .nav-item {
    position: relative;
    overflow: hidden;
  }
  
  .nav-item:hover {
    color: #FF3E00;
  }
  
  .nav-item::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background-color: #FF3E00;
    transition: width 0.3s ease, left 0.3s ease;
  }
  
  .nav-item:hover::after {
    width: 100%;
    left: 0;
  }
  
  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
</style>